import { Action } from '@ngrx/store';
import { RuleCommonParameterModel } from "../../models/RuleCommonParameterModel";

export const APPLY_COMMON_PARAMETERS_SUCCESS = '[Rule] Apply Common Parameter Success';

export class ApplyCommonParametersSuccessAction implements Action {
  readonly type = APPLY_COMMON_PARAMETERS_SUCCESS;

  constructor(public payload: { model: RuleCommonParameterModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/ApplyCommonParametersSuccessAction.ts